module.exports = __webpack_public_path__ + "teqbahn-assets/media/14.0e5ed620.png";